module.exports = __webpack_public_path__ + "img/img_G1.10.4.85b58e0c.png";